/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspacePermissionsRouteImport } from './routes/workspace-permissions'
import { Route as SnsContentGeneratorRouteImport } from './routes/sns-content-generator'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as PipelinesRouteImport } from './routes/pipelines'
import { Route as PipelinePermissionsRouteImport } from './routes/pipeline-permissions'
import { Route as OwnershipTransfersRouteImport } from './routes/ownership-transfers'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InfraGraphRouteImport } from './routes/infra-graph'
import { Route as DataViewerRegisterRouteImport } from './routes/data-viewer-register'
import { Route as DataViewerRouteImport } from './routes/data-viewer'
import { Route as ClaudeUsageRouteImport } from './routes/claude-usage'
import { Route as BotStatusRouteImport } from './routes/bot-status'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SnsContentGeneratorIndexRouteImport } from './routes/sns-content-generator/index'
import { Route as PipelinesIndexRouteImport } from './routes/pipelines/index'
import { Route as SnsContentGeneratorAccountIdRouteImport } from './routes/sns-content-generator/$accountId'
import { Route as SnsContentGeneratorTiktokCallbackRouteImport } from './routes/sns-content-generator/tiktok/callback'

const WorkspacePermissionsRoute = WorkspacePermissionsRouteImport.update({
  id: '/workspace-permissions',
  path: '/workspace-permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const SnsContentGeneratorRoute = SnsContentGeneratorRouteImport.update({
  id: '/sns-content-generator',
  path: '/sns-content-generator',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelinesRoute = PipelinesRouteImport.update({
  id: '/pipelines',
  path: '/pipelines',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelinePermissionsRoute = PipelinePermissionsRouteImport.update({
  id: '/pipeline-permissions',
  path: '/pipeline-permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnershipTransfersRoute = OwnershipTransfersRouteImport.update({
  id: '/ownership-transfers',
  path: '/ownership-transfers',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InfraGraphRoute = InfraGraphRouteImport.update({
  id: '/infra-graph',
  path: '/infra-graph',
  getParentRoute: () => rootRouteImport,
} as any)
const DataViewerRegisterRoute = DataViewerRegisterRouteImport.update({
  id: '/data-viewer-register',
  path: '/data-viewer-register',
  getParentRoute: () => rootRouteImport,
} as any)
const DataViewerRoute = DataViewerRouteImport.update({
  id: '/data-viewer',
  path: '/data-viewer',
  getParentRoute: () => rootRouteImport,
} as any)
const ClaudeUsageRoute = ClaudeUsageRouteImport.update({
  id: '/claude-usage',
  path: '/claude-usage',
  getParentRoute: () => rootRouteImport,
} as any)
const BotStatusRoute = BotStatusRouteImport.update({
  id: '/bot-status',
  path: '/bot-status',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SnsContentGeneratorIndexRoute =
  SnsContentGeneratorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SnsContentGeneratorRoute,
  } as any)
const PipelinesIndexRoute = PipelinesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PipelinesRoute,
} as any)
const SnsContentGeneratorAccountIdRoute =
  SnsContentGeneratorAccountIdRouteImport.update({
    id: '/$accountId',
    path: '/$accountId',
    getParentRoute: () => SnsContentGeneratorRoute,
  } as any)
const SnsContentGeneratorTiktokCallbackRoute =
  SnsContentGeneratorTiktokCallbackRouteImport.update({
    id: '/tiktok/callback',
    path: '/tiktok/callback',
    getParentRoute: () => SnsContentGeneratorRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bot-status': typeof BotStatusRoute
  '/claude-usage': typeof ClaudeUsageRoute
  '/data-viewer': typeof DataViewerRoute
  '/data-viewer-register': typeof DataViewerRegisterRoute
  '/infra-graph': typeof InfraGraphRoute
  '/login': typeof LoginRoute
  '/ownership-transfers': typeof OwnershipTransfersRoute
  '/pipeline-permissions': typeof PipelinePermissionsRoute
  '/pipelines': typeof PipelinesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sns-content-generator': typeof SnsContentGeneratorRouteWithChildren
  '/workspace-permissions': typeof WorkspacePermissionsRoute
  '/sns-content-generator/$accountId': typeof SnsContentGeneratorAccountIdRoute
  '/pipelines/': typeof PipelinesIndexRoute
  '/sns-content-generator/': typeof SnsContentGeneratorIndexRoute
  '/sns-content-generator/tiktok/callback': typeof SnsContentGeneratorTiktokCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bot-status': typeof BotStatusRoute
  '/claude-usage': typeof ClaudeUsageRoute
  '/data-viewer': typeof DataViewerRoute
  '/data-viewer-register': typeof DataViewerRegisterRoute
  '/infra-graph': typeof InfraGraphRoute
  '/login': typeof LoginRoute
  '/ownership-transfers': typeof OwnershipTransfersRoute
  '/pipeline-permissions': typeof PipelinePermissionsRoute
  '/settings': typeof SettingsRoute
  '/workspace-permissions': typeof WorkspacePermissionsRoute
  '/sns-content-generator/$accountId': typeof SnsContentGeneratorAccountIdRoute
  '/pipelines': typeof PipelinesIndexRoute
  '/sns-content-generator': typeof SnsContentGeneratorIndexRoute
  '/sns-content-generator/tiktok/callback': typeof SnsContentGeneratorTiktokCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bot-status': typeof BotStatusRoute
  '/claude-usage': typeof ClaudeUsageRoute
  '/data-viewer': typeof DataViewerRoute
  '/data-viewer-register': typeof DataViewerRegisterRoute
  '/infra-graph': typeof InfraGraphRoute
  '/login': typeof LoginRoute
  '/ownership-transfers': typeof OwnershipTransfersRoute
  '/pipeline-permissions': typeof PipelinePermissionsRoute
  '/pipelines': typeof PipelinesRouteWithChildren
  '/settings': typeof SettingsRoute
  '/sns-content-generator': typeof SnsContentGeneratorRouteWithChildren
  '/workspace-permissions': typeof WorkspacePermissionsRoute
  '/sns-content-generator/$accountId': typeof SnsContentGeneratorAccountIdRoute
  '/pipelines/': typeof PipelinesIndexRoute
  '/sns-content-generator/': typeof SnsContentGeneratorIndexRoute
  '/sns-content-generator/tiktok/callback': typeof SnsContentGeneratorTiktokCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bot-status'
    | '/claude-usage'
    | '/data-viewer'
    | '/data-viewer-register'
    | '/infra-graph'
    | '/login'
    | '/ownership-transfers'
    | '/pipeline-permissions'
    | '/pipelines'
    | '/settings'
    | '/sns-content-generator'
    | '/workspace-permissions'
    | '/sns-content-generator/$accountId'
    | '/pipelines/'
    | '/sns-content-generator/'
    | '/sns-content-generator/tiktok/callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bot-status'
    | '/claude-usage'
    | '/data-viewer'
    | '/data-viewer-register'
    | '/infra-graph'
    | '/login'
    | '/ownership-transfers'
    | '/pipeline-permissions'
    | '/settings'
    | '/workspace-permissions'
    | '/sns-content-generator/$accountId'
    | '/pipelines'
    | '/sns-content-generator'
    | '/sns-content-generator/tiktok/callback'
  id:
    | '__root__'
    | '/'
    | '/bot-status'
    | '/claude-usage'
    | '/data-viewer'
    | '/data-viewer-register'
    | '/infra-graph'
    | '/login'
    | '/ownership-transfers'
    | '/pipeline-permissions'
    | '/pipelines'
    | '/settings'
    | '/sns-content-generator'
    | '/workspace-permissions'
    | '/sns-content-generator/$accountId'
    | '/pipelines/'
    | '/sns-content-generator/'
    | '/sns-content-generator/tiktok/callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BotStatusRoute: typeof BotStatusRoute
  ClaudeUsageRoute: typeof ClaudeUsageRoute
  DataViewerRoute: typeof DataViewerRoute
  DataViewerRegisterRoute: typeof DataViewerRegisterRoute
  InfraGraphRoute: typeof InfraGraphRoute
  LoginRoute: typeof LoginRoute
  OwnershipTransfersRoute: typeof OwnershipTransfersRoute
  PipelinePermissionsRoute: typeof PipelinePermissionsRoute
  PipelinesRoute: typeof PipelinesRouteWithChildren
  SettingsRoute: typeof SettingsRoute
  SnsContentGeneratorRoute: typeof SnsContentGeneratorRouteWithChildren
  WorkspacePermissionsRoute: typeof WorkspacePermissionsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspace-permissions': {
      id: '/workspace-permissions'
      path: '/workspace-permissions'
      fullPath: '/workspace-permissions'
      preLoaderRoute: typeof WorkspacePermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sns-content-generator': {
      id: '/sns-content-generator'
      path: '/sns-content-generator'
      fullPath: '/sns-content-generator'
      preLoaderRoute: typeof SnsContentGeneratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipelines': {
      id: '/pipelines'
      path: '/pipelines'
      fullPath: '/pipelines'
      preLoaderRoute: typeof PipelinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline-permissions': {
      id: '/pipeline-permissions'
      path: '/pipeline-permissions'
      fullPath: '/pipeline-permissions'
      preLoaderRoute: typeof PipelinePermissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ownership-transfers': {
      id: '/ownership-transfers'
      path: '/ownership-transfers'
      fullPath: '/ownership-transfers'
      preLoaderRoute: typeof OwnershipTransfersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/infra-graph': {
      id: '/infra-graph'
      path: '/infra-graph'
      fullPath: '/infra-graph'
      preLoaderRoute: typeof InfraGraphRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-viewer-register': {
      id: '/data-viewer-register'
      path: '/data-viewer-register'
      fullPath: '/data-viewer-register'
      preLoaderRoute: typeof DataViewerRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-viewer': {
      id: '/data-viewer'
      path: '/data-viewer'
      fullPath: '/data-viewer'
      preLoaderRoute: typeof DataViewerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/claude-usage': {
      id: '/claude-usage'
      path: '/claude-usage'
      fullPath: '/claude-usage'
      preLoaderRoute: typeof ClaudeUsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bot-status': {
      id: '/bot-status'
      path: '/bot-status'
      fullPath: '/bot-status'
      preLoaderRoute: typeof BotStatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sns-content-generator/': {
      id: '/sns-content-generator/'
      path: '/'
      fullPath: '/sns-content-generator/'
      preLoaderRoute: typeof SnsContentGeneratorIndexRouteImport
      parentRoute: typeof SnsContentGeneratorRoute
    }
    '/pipelines/': {
      id: '/pipelines/'
      path: '/'
      fullPath: '/pipelines/'
      preLoaderRoute: typeof PipelinesIndexRouteImport
      parentRoute: typeof PipelinesRoute
    }
    '/sns-content-generator/$accountId': {
      id: '/sns-content-generator/$accountId'
      path: '/$accountId'
      fullPath: '/sns-content-generator/$accountId'
      preLoaderRoute: typeof SnsContentGeneratorAccountIdRouteImport
      parentRoute: typeof SnsContentGeneratorRoute
    }
    '/sns-content-generator/tiktok/callback': {
      id: '/sns-content-generator/tiktok/callback'
      path: '/tiktok/callback'
      fullPath: '/sns-content-generator/tiktok/callback'
      preLoaderRoute: typeof SnsContentGeneratorTiktokCallbackRouteImport
      parentRoute: typeof SnsContentGeneratorRoute
    }
  }
}

interface PipelinesRouteChildren {
  PipelinesIndexRoute: typeof PipelinesIndexRoute
}

const PipelinesRouteChildren: PipelinesRouteChildren = {
  PipelinesIndexRoute: PipelinesIndexRoute,
}

const PipelinesRouteWithChildren = PipelinesRoute._addFileChildren(
  PipelinesRouteChildren,
)

interface SnsContentGeneratorRouteChildren {
  SnsContentGeneratorAccountIdRoute: typeof SnsContentGeneratorAccountIdRoute
  SnsContentGeneratorIndexRoute: typeof SnsContentGeneratorIndexRoute
  SnsContentGeneratorTiktokCallbackRoute: typeof SnsContentGeneratorTiktokCallbackRoute
}

const SnsContentGeneratorRouteChildren: SnsContentGeneratorRouteChildren = {
  SnsContentGeneratorAccountIdRoute: SnsContentGeneratorAccountIdRoute,
  SnsContentGeneratorIndexRoute: SnsContentGeneratorIndexRoute,
  SnsContentGeneratorTiktokCallbackRoute:
    SnsContentGeneratorTiktokCallbackRoute,
}

const SnsContentGeneratorRouteWithChildren =
  SnsContentGeneratorRoute._addFileChildren(SnsContentGeneratorRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BotStatusRoute: BotStatusRoute,
  ClaudeUsageRoute: ClaudeUsageRoute,
  DataViewerRoute: DataViewerRoute,
  DataViewerRegisterRoute: DataViewerRegisterRoute,
  InfraGraphRoute: InfraGraphRoute,
  LoginRoute: LoginRoute,
  OwnershipTransfersRoute: OwnershipTransfersRoute,
  PipelinePermissionsRoute: PipelinePermissionsRoute,
  PipelinesRoute: PipelinesRouteWithChildren,
  SettingsRoute: SettingsRoute,
  SnsContentGeneratorRoute: SnsContentGeneratorRouteWithChildren,
  WorkspacePermissionsRoute: WorkspacePermissionsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
